/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PerturbationName
 */
export interface PerturbationName {
  /**
   *
   * @type {number}
   * @memberof PerturbationName
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbationName
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PerturbationName
   */
  displayName: string;
}

/**
 * Check if a given object implements the PerturbationName interface.
 */
export function instanceOfPerturbationName(value: object): value is PerturbationName {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('displayName' in value) || value['displayName'] === undefined) return false;
  return true;
}

export function PerturbationNameFromJSON(json: any): PerturbationName {
  return PerturbationNameFromJSONTyped(json, false);
}

export function PerturbationNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerturbationName {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    displayName: json['display_name'],
  };
}

export function PerturbationNameToJSON(value?: Omit<PerturbationName, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    display_name: value['displayName'],
  };
}
